<template>
  <div class="tab-pane" id="dtab3" role="tabpanel">
    <div class="row mt--10">
      <div class="col-md-5 pr-0 border-bottom border-dark">
        <h2 class="border-0 p-0 mb-0 mt-2">
          <span>Pläne</span>
        </h2>
      </div>
      <div class="col-md-1 col-lg-1 p-0 text-right border-bottom border-dark">
        <button class="btn btn-light ml-4 float-right" @click="setFlawRefPoint" v-if="isPoint && !pointsCount && selectedPlan">
          <i class="fa fa-dot-circle text-danger font1rem mt-1"></i>
        </button>
      </div>
      <div class="col-md-5 text-right border-bottom border-dark pr-1">
        <select class="form-control mb-1 plan-select" v-model="selectedPlan" @change="getPlanImage">
          <option value="" disabled>Select Plan</option>
          <option v-for="plan in allPlans" :value="plan" :disabled="checkPlan(plan.pdplanid)">
            {{plan.description}}
          </option>
        </select>
      </div>
      <div class="col-md-1 p-0 border-bottom border-dark">
        <button class="btn btn-success pr-3 pl-3" v-if="pointsCount && isBtnNewShow" @click="addNewCanvasPage" title="Add New Plan" style="line-height: 2.1">
          <i class="fa fa-plus"></i>
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col col-md-12">
        <div class="arrow-nxt-plan position-absolute shadow-sm border  p-1" v-if="pages.length && currentPage < pages.length" @click="pageChangeHandler(currentPage + 1)">
          <i class="fa fa-angle-right"></i>
        </div>
        <div class="arrow-prev-plan position-absolute position-absolute shadow-sm border  p-1" v-if="pages.length && currentPage !== 1" @click="pageChangeHandler(currentPage - 1)">
          <i class="fa fa-angle-left"></i>
        </div>
        <div class="mapthumb canvas-box screen-height p-0 mx-auto mb-1">
          <img src="@/assets/images/delete_icon.png" alt="delete" width="20" class="delete-img position-absolute" title="Remove" v-if="selectedPlan" @click="removePlan">
          <div v-if="isPlan" class="zoom-box" style="padding-left: 6px; padding-right: 6px; -webkit-box-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);">
            <div class="zoom-out">
              <button id="zoom-out" @click="zoomOut">
                <img class="img-responsive" src="@/assets/images/minus.png" style="width: 12px" alt="shap">
              </button>
            </div>
            <div class="zoom-input">
              <input type="range"  v-model="zoomRange" id="zoom-input" min="1" max="2000" step="4" class="slider" >
            </div>
            <div class="zoom-in">
              <button id="zoom-in" @click="zoomIn">
                <img class="img-responsive" src="@/assets/images/plus_c.png" style="width: 12px" alt="shap">
              </button>
            </div>
          </div>
          <h5 v-if="!isPlan" class="p-3 text-center"> Wählen Sie einen Plan über das Dropdown-Menü </h5>
          <canvas  ref="canvas" id="canvas" class="img-fluid"></canvas>
        </div>

        <div class="border-top border-dark  docs-pagination col-md-12 bg-white text-center" v-if="pages.length > 0">
          <div class="p-0">
            <sliding-pagination
              :current="currentPage"
              :total="pages.length"
              @page-change="pageChangeHandler"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {fabric} from 'fabric'
import SlidingPagination from 'vue-sliding-pagination'
import { mapState } from 'vuex'

export default {
  components: { SlidingPagination },
  data(){
    return {
      selectedPlan: null,
      canvas: null,
      offset_left: 0.00,
      h_dif: 0,
      w_dif: 0,
      image: null,
      zoomRange: 1,
      isPlan: false,
      isPoint: false,
      currentPage: 1,
      pageFlags: [],
      images: [],
      pages: [],
      isBtnNewShow: false
    }
  },
  computed: {
    ...mapState({
      plan: state => state.tasks.taskPlanImage,
      authUser: state => state.projects.user,
      is_loading: state => state.constructionDiary.is_loading,
      flags: state => state.tasks.editTaskDetails.pdflawflags
    }),
    allPlans(){
     return this.$store.state.plans.allPlans
    },

    pointsCount(){
      if (this.canvas){
        return this.canvas.getObjects().length
      }else {
        return 0
      }
    },
  },
  mounted () {
    this.getFirstPlanCanvas();
  },
  methods: {
   async getFirstPlanCanvas(){
     this.$store.commit('loading',true)
     let pages = [];
     this.flags.forEach(item => { pages.push('pages') });
     this.pages = pages
     if (this.allPlans < 1){
       await this.$store.dispatch("getAllPlans",this.$route.params.id);
     }
     let _this = this
     $('.btn-plan-tab').on('click', function() {
       if (_this.pages.length){
         _this.$store.commit('loading',true)
         _this.pageChangeHandler(1)
       }
       _this.$store.commit('loading',false)
     })
   },

    async getPlanImage () {
      if (this.canvas) {
        this.canvas.clear()
        this.canvas.dispose()
      }
      this.isBtnNewShow = true
      this.$store.commit('loading', true)
      let _this = this
      if (!_this.selectedPlan.src){
        await fetch(`${process.env.VUE_APP_GET_METHOD_URL}img&id=${this.selectedPlan.pdplanid}&isplan=1&type=l&token=${localStorage.sessiontoken}`, {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: 'string'
          }
        }).then(response => response.blob())
          .then(response => {
            let reader = new FileReader()
            reader.readAsDataURL(response)
            reader.onload = function () {
              _this.selectedPlan.src = reader.result
              _this.setImageInCanvas();
            }
          });
      } else {
        _this.setImageInCanvas()
      }
    },

    setImageInCanvas(){
      const canvas = this.createCanvas();
      this.setPlanPhotoInCanvas(canvas)
      this.canvas = canvas
      this.isPlan = true
      this.isPoint = true
      this.$store.commit('loading', false)
    },

    createCanvas () {
      const ref = this.$refs.canvas
      return new fabric.Canvas(ref, {
        selection: false,
        controlsAboveOverlay: true,
        centeredScaling: true,
        allowTouchScrolling: true,
        hasBorders: false,
        lockRotation: false,
        lockMovement: false,
        lockMovementY: false,
        lockMovementX: false,
        lockUniScaling: false,
        lockScalingY: false,
        lockScalingX: false,
        originX: 'middle',
        originY: 'middle',
        preserveObjectStacking: false,
        pointDragTrue: false,
      })
    },

    async setPlanPhotoInCanvas (canvas) {
      let _this = this
      await fabric.Image.fromURL(this.selectedPlan.src, function (img) {
        let hgt = document.querySelector('.canvas-box').offsetHeight;
        const canvas_width = document.querySelector('.canvas-box').offsetWidth

        const hPer = (hgt / img.height) * 100
        let width = (img.width / 100) * hPer

        if ( width > canvas_width ) {
          const wdh_difference = width - canvas_width
          const w_dif_per = (wdh_difference / width) * 100
          const cal_hgt = (hgt / 100) * w_dif_per
          hgt = hgt - cal_hgt;
          width = canvas_width
        }

        const hPerForOffset = (hgt / img.height) * 100
        const widthForOffset = (img.width / 100) * hPerForOffset
        _this.offset_left = (canvas_width - widthForOffset) / 2

        const image_height = document.querySelector('.canvas-box').offsetHeight;
        const widthForOffsetTop = (width / img.width) * 100
        const heightForOffsetTop = (img.height / 100) * widthForOffsetTop
        _this.offset_top = (image_height - heightForOffsetTop) / 2
        canvas.setHeight(hgt)
        canvas.setWidth(width)

        _this.image = img
        _this.images.height = img.height
        _this.images.width = img.width

        _this.h_dif = (hgt / img.height) * 100
        _this.w_dif = (width / img.width) * 100


        canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          backgroundImageStretch: true
        })

        img.set({
          centeredRotation: true,
          centeredScaling: true,
          originX: 'middle',
          originY: 'middle',
          scaleX: canvas.width / img.width,
          scaleY: canvas.height / img.height
        })
        canvas.renderAll()

        canvas.setWidth(canvas_width)
        const div_height = document.querySelector('.canvas-box').offsetHeight;
        canvas.setHeight(div_height);
        canvas.centerObject(img)
        _this.canvas = canvas
        //Add events on canvas
        _this.addEventsOnCanvas(canvas)
      });
    },



    addEventsOnCanvas (canvas) {
      let _this = this
      canvas.on('mouse:wheel', function (opt) {
        _this.pointBox = false
        if (opt.e.deltaY > 0) {
          _this.zoomOut()
        } else {
          _this.zoomIn()
        }
      })
      let panning = false
      canvas.on('mouse:up', function (e) {
        panning = false
      })

      canvas.on('mouse:down', function (e) {
        panning = true
      })

      canvas.on('object:moving', function (e) {
        panning = false
      })

      canvas.on('mouse:move', function (e) {
        if (panning && e && e.e) {
          if (this.pointDragTrue === false) {
            let delta = new fabric.Point(e.e.movementX, e.e.movementY)
            canvas.relativePan(delta)
            let canvasViewPort = canvas.viewportTransform

            let bottomEndPoint = canvas.height * (canvasViewPort[0] - 1)
            if (canvasViewPort[5] >= 0 || -bottomEndPoint > canvasViewPort[5]) {
              canvasViewPort[5] = (canvasViewPort[5] >= 0) ? 0 : -bottomEndPoint
            }
            let rightEndPoint = canvas.width * (canvasViewPort[0] - 1)
            if (canvasViewPort[4] >= 0 || -rightEndPoint > canvasViewPort[4]) {
              canvasViewPort[4] = (canvasViewPort[4] >= 0) ? 0 : -rightEndPoint
            }
          }
        }
      })
    },

    zoomOut () {
      if (this.zoomRange >= 1) {
        this.zoomRange = (Math.floor(this.zoomRange)) - (4)
      }
    },

    zoomIn () {
      if (this.zoomRange < 2000) {
        this.zoomRange = (Math.floor(this.zoomRange)) + (4)
      }
    },

    setFlawRefPoint () {
      let planFlag = {
        created: "",
        degree: 0,
        lastupdate: null,
        pdflawflagid: 0,
        pdflawid: 0,
        pdplanid: this.selectedPlan.pdplanid, // plan id is here from selected plan
        pdpositionid: null,
        pdprojectid: this.$route.params.id,
        tiltangle: 0,
        viewx: 100,
        viewy: 0,
        xcoord: 0,
        ycoord: 0,
        _explicitType: "com\\projectdocu\\PDFlawFlagVO"
      }

      this.flags[this.currentPage - 1] = planFlag
      this.drawRefPointOnCanvas(planFlag)
    },

    drawRefPointOnCanvas (data) {
      let item = this.selectedPlan
      let point = this.createRefPoint();
      let position = this.calculatePositionOnCanvas(data.xcoord, data.ycoord);
      this.canvas.add(point.set({
        left: position.x,
        top: position.y,
        data: item
      }));
      this.addEventsOnPoint(point);
      this.setPointsZoom(this.zoomRange, point)
      this.canvas.setActiveObject(point)
      this.canvas.renderAll()
    },

    createRefPoint () {
      return new fabric.Circle({
        fill: 'red',
        hasBorder: true,
        stroke: 'red',
        strokeWidth: 5,
        originX: 'middle',
        originY: 'middle',
        radius: 7,
        hasControls: false,
        selection: false,
        allowTouchScrolling: true,
        hasBorders: true,
        hoverCursor: 'default',
      })
    },

    addEventsOnPoint (point) {
      let _this = this
      point.on('mouseup', function (e) {
        const coords = {'x': _this.canvas.getPointer(event).x, 'y': _this.canvas.getPointer(event).y}
        _this.flags[_this.currentPage - 1].xcoord = (((coords.x - _this.offset_left) / _this.w_dif) * 100) - (_this.image.width / 2)
        _this.flags[_this.currentPage - 1].ycoord = (((coords.y - _this.offset_top) / _this.h_dif) * 100) - (_this.image.height / 2)
      })
    },

    //Math Formula to calculate the position
    calculatePositionOnCanvas (xcoord, ycoord) {
      let img = this.image
      let ow = this.offset_left
      let iw = img.width
      let ih = img.height
      let hdif = this.h_dif
      let wdif = this.w_dif

      let x = (((xcoord + (iw / 2)) / 100) * wdif) + ow
      let y = (((ycoord + (ih / 2)) / 100) * hdif) + this.offset_top
      return {x: x, y: y}
    },

    setPointsZoom (range, obj) {
      let r = (1500 / range) * 0.125
      if (range <= 25) {
        obj.set({
          radius: 4.7,
          strokeWidth: 4.7 / 2
        })
      } else if (range < 60 && range >= 25) {
        if (r > 3.47) {
          obj.set({
            radius: 3.46,
            strokeWidth: 3.40 / 2
          })
        }
      } else if (range > 400) {
        obj.set({
          radius: 0.515,
          strokeWidth: 0.49 / 2
        })
      } else {
        obj.set({
          radius: r,
          strokeWidth: r / 2
        })
      }
    },

    async pageChangeHandler(page){
      this.$store.commit('loading',true)
      this.zoomRange = 1
      this.currentPage = page
      let flag = this.flags[page - 1] || null
      if (flag) {
        this.selectedPlan = await this.allPlans.find(item => item.pdplanid.toString() === flag.pdplanid.toString())
        await this.getPlanImage();
        let _this = this
        this.$store.commit('loading',true)
        setTimeout(function(){
          _this.drawRefPointOnCanvas(flag)
          _this.$store.commit('loading',false)
        }, 400)
      }else {
        if (this.canvas) {
          this.canvas.clear()
          this.canvas.dispose()
        }
        this.canvas = null
        this.selectedPlan = null
        this.$store.commit('loading',false)
      }
    },


    addNewCanvasPage () {
      this.selectedPlan = null
      this.currentPage = this.pages.length + 1
      this.isBtnNewShow = false
      if (this.canvas) {
        this.canvas.clear()
        this.canvas.dispose()
        this.canvas = null
      }
      this.pages.push({'new-page':'new'})
    },

    checkPlan(id){
      let ids = this.flags.map(item => item.pdplanid)
      return ids.includes(Math.floor(id))
    },
    async removePlan () {
      if (this.canvas) {
        this.canvas.clear()
        this.canvas.dispose()
      }
      this.canvas = null
      let flag = null
      this.selectedPlan = null

      this.$store.commit('loading',true)
      let index = this.currentPage - 1
      this.isBtnNewShow = false
      if (this.pages.length && this.flags.length) {
        if (this.currentPage === 1 && this.pages.length >= 2){
          flag = this.flags[index + 1]
          this.currentPage = index + 1
        }else {
            flag = this.flags[index - 1]
            this.currentPage = index
        }

        console.log('FlagSelect'. flag)

        this.pages.splice(0,1)
        this.flags.splice(index , 1)
        if(this.selectedPlan != null && flag !== null && flag.pdplanid !== null) {
          this.selectedPlan = await this.allPlans.find(item => item.pdplanid.toString() === flag.pdplanid.toString())
          await this.getPlanImage();
          let _this = this
          setTimeout(function(){
            _this.drawRefPointOnCanvas(flag)
            _this.$store.commit('loading',false)
          }, 400);
        }

        this.$store.commit('loading',false)
      } else {
        this.$store.commit('loading',false)
      }
    }
  },

  watch: {
    zoomRange: function (range) {
      let canvas = this.canvas
      let c = (range / 55) + 1
      canvas.zoomToPoint({x: canvas.getWidth() / 2, y: canvas.getHeight() / 2}, c)
      canvas.setZoom(c);
      let point = this.canvas.getObjects()[0];
      if (point) {
        this.setPointsZoom(this.zoomRange, point)
      }
    },
    '$parent.task': function (val) {
      let pages = [];
      val.pdflawflags.forEach(item => {
        pages.push('pages')
      });
      this.pages = pages
      this.pageChangeHandler(1);
    },
  }
}


</script>
<style scoped>
.arrow-nxt-plan.position-absolute{
  display: table;
  right: -7px;
  top:0;
  height: calc(100vh - 276px) !important;
  cursor: pointer;
  z-index: 99;
  background: #FFFFFF;
}
.arrow-prev-plan.position-absolute{
  display: table;
  left: -7px;
  top:0;
  height: calc(100vh - 276px) !important;
  cursor: pointer;
  z-index: 99;
  background: #FFFFFF;
}
.arrow-prev-plan .fa,.arrow-nxt-plan .fa{
  display: table-cell;
  vertical-align: middle;
  font-size: 3rem;
}
.canvas-box.screen-height{
  height: calc(100vh - 277px) !important;
  overflow-x: hidden;
}
input.service-checkbox{
  vertical-align: middle;
}
.doku-btns-sticky{
  bottom: 1px;
  z-index: 100;
  position: absolute;
  width: 81%;
  text-align: center;
  background: #ffffff7a;
  border-top: 1px solid grey;
}
.form-control.plan-select{
  height: 2rem;
  padding: 2px 7px;
  font-weight: bold;
}
.doku-btns-sticky button{
  font-size: 14px;
  font-weight: normal !important;
  padding: 6px 18px;
  line-height: 1.2;
}
.scroll-services{
  max-height: 15.5rem;
  overflow-x: hidden;
  overflow-y:auto ;
}
.create-height.screen-height{
  height: calc(100vh - 103px) !important;
}
.scroll-services::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .6);
  background-color: #3399ff9e;
  opacity: 1;
}
.scroll-services::-webkit-scrollbar {
  width: 6px;
  background-color: #bebaba;
}
.mt--10{
  margin-top: -7px;
}
.zoom-box{
  top: 3px;
  left: 5px;
  z-index: 99999;
}
.delete-img.position-absolute{
  right: 5px;
  top: 2px;
  cursor: pointer;
  z-index: 99;
}
</style>



// WEBPACK FOOTER //
// src/components/tasks/EditTaskCanvas.vue